export default __webpack_public_path__ + "static/media/conta.f6a9945d.png";